// React libraries
import React from "react";
// Custom Styles
import { useStyles } from "./ModalStyles";
export const Modal = (props) => {
    const classes = useStyles(props);
    const { width, height, isModalOpen, zIndex } = props;
    const marginLeft = width / 2 * -1;
    const marginTop = height / 2 * -1;
    return (React.createElement("div", { style: {
            display: isModalOpen ? "block" : "none"
        } },
        React.createElement("div", { className: classes.overlay }),
        React.createElement("div", { className: classes.modal, style: { marginLeft: marginLeft, marginTop: marginTop, height: height, width: width } }, props.children)));
};
export default React.memo(Modal);
